import React, { useState, useEffect } from 'react';
import { Header, Button, Alert, Loading, Typeahead } from '../../Components';
import { APIS } from '../../Config/apis';
import * as QLIBS from '../../qLibsHelpers';
import { GLOBAL } from '../../Config/global';
import { FORM_ERRORS } from "../../Config/form_errors";
import { Redirect, useHistory } from "react-router-dom";
import userAuth from '../../Config/userauth';
import loginImageDesktop from "../../Resources/Images/FormImages/pantalla-login.jpg";
import toolsImg from "../../Resources/Images/FormImages/tools.png";
import * as utils from '../../Shared/Utils';
import { ValidarCuit } from '../../Shared/Utils/form_validation';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';

const SimulateProducer = () => {
    const history = useHistory();
    const [loadingForm, setLoadingForm] = useState(false);
    const [error, setError] = useState('');
    const [redirect, setRedirect] = useState(null);
    const [cuit, setCuit] = useState('');
    const [parent, setParent] = useState([]);
    const [child, setChild] = useState([]);

    const [errorCuit, setErrorCuit] = useState('');
    const [errorNombre, setErrorNombre] = useState('');
    const [errorCuitBorderColor, setErrorCuitBorderColor] = useState('');
    const [errorNombreBorderColor, setErrorNombreBorderColor] = useState('');

    useEffect(() => {
        if (!userAuth.requestSelectProducer()) {
            userAuth.cleanSimulator();
        }
    }, []);

    const handleChange = ({ target }) => {
        const { name, value } = target;
        if (name === 'cuit') {
            const cleanCuit = value.replace(/-/g, "").trim();
            if (cleanCuit.length !== 11 || !ValidarCuit(cleanCuit)) {
                setErrorCuit(`${FORM_ERRORS.COMMON_ERRORS.INITIAL_MARKER}${FORM_ERRORS.COMMON_ERRORS.CUIT_INVALID}`);
                setErrorCuitBorderColor("error");
                setErrorNombreBorderColor("error");
            } else {
                setErrorCuit('');
                setErrorCuitBorderColor("success");
                setErrorNombreBorderColor("success");
            }
            setCuit(value);
        }
    };

    const validate = () => {
        let valid = true;
        const cleanCuit = cuit.replace(/-/g, "").trim();

        setErrorCuit('');
        setErrorNombre('');
        setErrorCuitBorderColor('');
        setErrorNombreBorderColor('');

        if (cleanCuit.length !== 11 || !ValidarCuit(cleanCuit)) {
            setErrorCuit(`${FORM_ERRORS.COMMON_ERRORS.INITIAL_MARKER}${FORM_ERRORS.COMMON_ERRORS.CUIT_INVALID}`);
            setErrorCuitBorderColor("error");
            valid = false;
        } else {
            setErrorCuitBorderColor("success");
        }

        if (!child.length || !child[0].value) {
            setErrorNombre(`${FORM_ERRORS.COMMON_ERRORS.INITIAL_MARKER}${FORM_ERRORS.CUSTOM_ERRORS.SIMULAR_PRODUCTOR_NOMBRE_ERROR}`);
            setErrorNombreBorderColor("error");
            valid = false;
        } else {
            setErrorNombreBorderColor("success");
        }

        return valid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoadingForm(true);
        try {
            const response = await QLIBS.fetchDataPOST(APIS.URLS.SIMULATE_PRODUCER, {
                Cuit: cuit,
                UserId: userAuth.userId()
            }, true);

            if (response?.success && !response.businessExceptions?.length) {
                userAuth.setUserIdProducer(
                    response.userId,
                    response.name ?? response.userFirstName,
                    cuit,
                    response.sysData,
                    response.reportTo_Cuit,
                    response.roles[0]
                );
                setRedirect('/home');
            } else {
                setError(response.businessExceptions?.map(x => x.message.replace('<br/>', '\n')).join('') || 'Error inesperado');
                setLoadingForm(false);
            }
        } catch (err) {
            setError('Error inesperado');
            setLoadingForm(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            document.getElementById("btnSubmit").click();
        }
    };

    const onClickAdvanced = () => {
        if (userAuth.isAuthenticated()) {
            utils.setStorage('menuAdvanced', true);
            setRedirect("/avanzadas");
        }
    };
    if (redirect) return <Redirect to={redirect} />;

    return (
        <section>
            <Loading visible={loadingForm} />
            <Header
                {...history}
                showBackButton={false}
                showNotificationPanel
                showProfileBadge
                showNavbar={false}
                showHamburgerMenu
                token={true}
            />
            <section>
                <div className="container">
                    <div className="opciones">
                        <div className="simulate-opcion shadow">
                            <img src={loginImageDesktop} alt="Simular Productor" />

                            {error && (
                                <div className="col-12 my-2">
                                    <Alert
                                        icon="times"
                                        message={error}
                                        title={GLOBAL.SIMULATE_FORM.ERROR_SIMULATE_PRODUCER}
                                        type="errorMessage"
                                    />
                                </div>
                            )}

                            <form id="simular-form" onSubmit={handleSubmit} onKeyDown={onKeyDown} noValidate>
                                <h3>{GLOBAL.PAGES.TITLE.SIMULATEPRODUCER}</h3>
                                <p>Ingresa a la web como si fuera un productor</p>
                                <br />

                                <Typeahead
                                    id="cuit"
                                    label={GLOBAL.COMMON_SEARCH_FORM.PRODUCTOR_CUIT}
                                    placeholder={GLOBAL.COMMON_SEARCH_FORM.PRODUCTOR_CUIT_PLACEHOLDER}
                                    SEARCH_URI={APIS.URLS.PRODUCER_AUTOCOMPLETE_BY_CUIT}
                                    selected={parent}
                                    onSelected={(selected) => {
                                        const array = [{ id: selected.id, value: selected.value, unregistered: selected.message === 'U' }];
                                        setParent(array);
                                        setChild(array);
                                        handleChange({ target: { name: 'cuit', value: selected.id, unregistered: selected.message === 'U' } });
                                    }}
                                    onClean={() => { setParent([]); setCuit(''); }}
                                    labelKey="id"
                                    errorMsg={errorCuit}
                                    borderColor={errorCuitBorderColor}
                                />

                                <Typeahead
                                    id="nombre"
                                    label={GLOBAL.COMMON_SEARCH_FORM.PRODUCTOR_NOMBRE}
                                    placeholder={GLOBAL.COMMON_SEARCH_FORM.PRODUCTOR_NOMBRE_PLACEHOLDER}
                                    SEARCH_URI={APIS.URLS.PRODUCER_AUTOCOMPLETE_BY_NAME}
                                    selected={child}
                                    onSelected={(selected) => {
                                        const array = [{ id: selected.id, value: selected.value, unregistered: selected.message === 'U' }];
                                        setParent(array);
                                        setChild(array);
                                        handleChange({ target: { name: 'cuit', value: selected.id, unregistered: selected.message === 'U' } });
                                    }}
                                    onClean={() => { setChild([]); setCuit(''); }}
                                    labelKey="value"
                                    errorMsg={errorNombre}
                                    borderColor={errorNombreBorderColor}
                                />

                                <Button type="submit" id="btnSubmit">{GLOBAL.SIMULATE_FORM.SUBMIT_BUTTON}</Button>

                                {child[0]?.unregistered && (
                                    <span className="alertUnregistered">
                                        <p><i className="fas fa-info-circle icon"></i> El productor seleccionado <b>no está registrado</b>, algunas opciones pueden no estar disponibles</p>
                                    </span>
                                )}
                            </form>
                        </div>

                        <div className="opcion-form shadow">
                            <img src={toolsImg} alt="Opciones avanzadas" />
                            <h3>{GLOBAL.PAGES.TITLE.OPCIONES_AVANZADAS}</h3>
                            <p>Permite restablecer contraseña, agregar nuevos usuarios, etc.</p>
                            <Button type="button" onClick={onClickAdvanced}>Avanzado</Button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};


export default SimulateProducer;
